import React from 'react';
import PropTypes from 'prop-types';
import Section from '../components/section';
import Review from '../components/review';

const ReviewsJSON = ({
  items,
  address: {
    streetAddress, addressLocality, addressRegion, postalCode, addressCountry,
  },
  geo: { latitude, longitude },
  title,
  siteUrl,
  image,
  telephone,
}) => {
  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    '@id': siteUrl,
    name: title,
    image,
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      streetAddress,
      addressLocality,
      addressRegion,
      postalCode,
      addressCountry,
    },
    telephone,
    geo: {
      '@type': 'GeoCoordinates',
      latitude,
      longitude,
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      bestRating: '5',
      worstRating: '1',
      ratingCount: items.length,
    },
    review: items.map(({
      node: {
        name, email, created, comment: { json: comment },
      },
    }) => Review.JSONLD({
      name,
      email,
      comment,
      created,
    })),
  };
  return jsonld;
};

const Reviews = ({ items }) => (
  <Section title="Отзывы" className="reviews">
    {/* <div className="box-container">
      <div className="box-title">Оставьте отзыв</div>
      <div className="box-content">
        <div className="form-group">
          <div className="form-control">
            <textarea className="textarea" id="textarea1" placeholder="Текст" cols="" rows="8" />
          </div>
        </div>
        <div className="form-group">
          <div className="form-control">
            <div className="form-element person">
              <input className="input" id="input-3" type="text" placeholder="Имя" />
            </div>
          </div>
          <div className="form-control">
            <div className="form-element email">
              <input className="input" id="input-3" type="text" placeholder="Почта" />
            </div>
          </div>
        </div>
        <button type="submit" className="btn">
          Отправить
        </button>
      </div>
    </div> */}
    <div className="comments-item">
      <div className="title-group">
        <h2 className="title-2">Отзывы</h2>
        <span className="comment-sum">
          {items.length}
          {' отзывов'}
        </span>
      </div>
      {items.map(({
        node: {
          id, name, email, created, comment: { json: comment },
        },
      }) => (
        <Review
          {...{
            name,
            email,
            created,
            comment,
          }}
          key={id}
        />
      ))}
    </div>
  </Section>
);

Reviews.JSONLD = ReviewsJSON;

Reviews.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Reviews;
